import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { Slugify } from '@bd/bdcore-utilities';
import RouteCollection, { Redirect } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';

import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuGallery from '../../components/MenuGallery';
import GalleryToggler from './GalleryToggler';
import VideoGalleryList from './VideoGalleryList';
import { colors, typography } from '../../styles';

const styles = css`

  .Gallery_inner {
    margin: 0 auto;
  }
  .Gallery_header {
    font-size: 30px;
    font-family: ${typography.objektiv};
    font-weight: 300;
    letter-spacing: 0.94px;
    line-height: 43px;
    text-align:center;
    background-color: ${colors.bg};
    padding: 24px 0;
    position: relative;
    margin-bottom: 67px;
    @media (min-width: 768px) {
      font-size: 42px;
      letter-spacing: 1.31px;
      line-height: 61px;
      padding-bottom: 55px;
      padding-top: 49px;
      margin-bottom: 80px;
    }
  }
`;

class VideoGallery extends React.Component {
  constructor(props) {
    super(props);

    const activeCategory = {};
    const route = RouteCollection.getRouteByPath(get(this.props.router, 'location.pathname'));
    const routeParam = get(route, 'params.gallery');
    const videos = this.props.page.category;
    if (routeParam) {
      const matchingGallery = videos.find(gallery => Slugify(get(gallery, 'category_name')) === routeParam);
      activeCategory.name = get(matchingGallery, 'category_name');
      activeCategory.param = routeParam;
    } else {
      const firstCategoryName = get(videos, '[0].category_name');
      activeCategory.name = firstCategoryName;
      activeCategory.param = Slugify(firstCategoryName);
    }

    this.state = {
      activeCategory,
      videoCount: 6,
    };
  }

  toggleCategory = category => {
    this.setState({
      activeCategory: {
        name: category,
        param: Slugify(category),
      },
    });
  }

  showVideos = () => {
    this.setState({
      videoCount: Infinity,
    });
  }

  hideVideos = () => {
    this.setState({
      videoCount: 6,
    });
  }

  render() {
    const { page } = this.props;
    const { activeCategory, videoCount } = this.state;
    const categories = get(page, 'category').map(video => get(video, 'category_name'));
    const activeGallery = get(page, 'category').find(gallery =>
      Slugify(get(gallery, 'category_name')) === activeCategory.param);
    if (activeGallery) {
      const activeGalleryVideos = get(activeGallery, 'video_gallery');
      return (
        <PageWrapper className={styles}>
          <PageHelmet
            custom
            title={`${get(activeCategory, 'name')} Video Gallery`}
          />
          <InsideHeader
            h1={`${page.metaTags.title}`}
            background={get(page, 'page_image')}
          />
          <MenuGallery />
          <div className="Gallery_inner">
            <GalleryToggler
              activeCategory={activeCategory.param}
              categories={categories}
              toggleCategory={this.toggleCategory}
              hideVideos={this.hideVideos}
            />
            <h2 className="Gallery_header">{activeCategory.name}</h2>
            <VideoGalleryList
              videos={activeGalleryVideos}
              videoCount={videoCount}
              showVideos={this.showVideos}
            />
          </div>
        </PageWrapper>
      );
    }
    return (
      <Redirect name="media-and-press" />
    );
  }
}

VideoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'video_gallery',
    router: true,
  },
  {
    ifMissing404: true,
  },
)(VideoGallery);



// WEBPACK FOOTER //
// ./src/pages/VideoGallery/index.js